module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<form novalidate='true'>\n  <div class='component-auth__form'></div>\n  <div class='component-auth__error' role='alert'></div>\n  <button class='component-auth__submit' type='submit'></button>\n</form>\n<div class='component-auth__sso-providers-divider'>\n  <div class='component-auth__sso-providers-divider__line'></div>\n  <div class='component-auth__sso-providers-divider__label'>Or</div>\n</div>\n<div class='component-auth__sso-providers-container'></div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
